import CustomInput from "../../components/CustomInput";
import form_styles from "../../components/SpecificStyles/form.module.css";
import PersonIcon from "@mui/icons-material/Person";
import { useEffect, useState } from "react";
import ControlButton from "../../components/ControlButtom";
import {
  Microphone,
  MicrophoneSlash,
  VideoCamera,
  VideoCameraSlash,
} from "@phosphor-icons/react";
import { useSelector } from "react-redux";
import ChangeCamModal from "../changeCamModal";
import { Settings } from "@mui/icons-material";
import { getLanguageTexts, getSelectedLanguage } from "../../languages";
import Loader from "../../components/Loader";

export default function UserInfoForm({
  roomName,
  handleRoomName,
  handleConnect,

  username,
  handleUsername,

  // media control
  handleStartMedia,
  localVideo,

  // streaming control
  localStream,
  enableVideoStream,
  handleEnableVideoStream,
  enableAudioStream,
  handleEnableAudioStream,
  student,
  closeCall,
  number_online,isStartMedia,
  devicesMic,
          devicesCam,
          deviceCamSelect,
          deviceMicSelect,
          setDeviceCamSelect,
          setDeviceMicSelect,
          setDevicesCam,
          setDevicesMic,
}) {
  useEffect(() => {
      handleStartMedia();
  }, []);
  
  const socket = useSelector(store=>store.AppReducer.socket);
  const user = useSelector(store=>store.AppReducer.user);
  const [change_cam_modal,setChangeCamModal] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(getSelectedLanguage());
  const t = getLanguageTexts(selectedLanguage);

  useEffect(() => {
    const handleLanguageChange = () => setSelectedLanguage(getSelectedLanguage());
    window.addEventListener('avaliador_language_change', handleLanguageChange);
    return () => window.removeEventListener('avaliador_language_change', handleLanguageChange);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100dvh",
        gap: "3rem",
        position:'fixed',
        top:0,
        left:0,
        right:0,
        bottom:0,
        background: 'var(--background-color0)',
        flexWrap: 'wrap',
        overflowY: 'auto',
        overflowX: 'hidden',
        WebkitOverflowScrolling: 'touch',
        padding: '24px'
      }}
      className={"avaliador-meet-page avaliador-meet-lobby " + ((localStorage.getItem('avaliador_theme') || 'light') == 'dark' ? 'dark-mode' : 'white-mode')}
    >
      <ChangeCamModal
        {...{
          devicesMic,
          devicesCam,
          deviceCamSelect,
          deviceMicSelect,
        }}
        handleEnableAudioStream={(force)=>handleEnableAudioStream(localStream.current,true,force)}
        handleEnableVideoStream={(force)=>handleEnableVideoStream(localStream.current,true,force)}
        change_cam_modal={change_cam_modal}
        setChangeCamModal={(e)=>setChangeCamModal(e)}
        mudarDevices={(e)=>{
          setDeviceCamSelect(e.deviceCamSelect)
          setDeviceMicSelect(e.deviceMicSelect)
        }}

      
      />
      {isStartMedia==true && <div style={{position:'absolute',top:50,right:50}}>
        <i className="mdi mdi-close" style={{fontSize:25,cursor:'pointer'}} onClick={()=>{
          closeCall();
        }}  ></i>

      </div>}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            backgroundColor: "var(--background-color1)",
            borderRadius: "0.6rem",
            overflow: "hidden",
            position: "relative",
            height: "20rem",
            justifyContent: "center",
            aspectRatio: "16/9",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "20rem",
              backgroundColor: "black",
              display: enableVideoStream ? "none" : "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1.4rem",
              padding: "0 6rem",
              color: "white",
              position: "absolute",
            }}
          >
            {t.camera_off}
          </div>
          <video
            ref={localVideo}
            autoPlay
            style={{
              maxWidth: "100%",
              maxHeight: "20rem",
              objectFit: "contain",
              borderRadius:10,
            }}
          ></video>
        </div>

        <div
          style={{
            display: "flex",
            gap: "1rem",
            justifyContent:'center',
            alignItems:'center'
          }}
        >
          <ControlButton
            tooltip={enableVideoStream ? t.turn_camera_off : t.turn_camera_on}
            icon={
              enableVideoStream ? (
                <VideoCamera weight="fill" />
              ) : (
                <VideoCameraSlash />
              )
            }
            onClick={() =>
              enableVideoStream
                ? handleEnableVideoStream(localStream.current, false)
                : handleEnableVideoStream(localStream.current, true)
            }
          />
          <ControlButton
            tooltip={
              enableAudioStream ? t.turn_microphone_off : t.turn_microphone_on
            }
            icon={
              enableAudioStream ? (
                <Microphone weight="fill" />
              ) : (
                <MicrophoneSlash />
              )
            }
            onClick={() =>
              enableAudioStream
                ? handleEnableAudioStream(localStream.current, false)
                : handleEnableAudioStream(localStream.current, true)
            }
          />

           <ControlButton
            tooltip={
             t.settings
            }
            icon={
             
                <Settings weight="fill" />
             
            }
            onClick={() =>{
              setChangeCamModal(true)
            }
              
            }
          />
        </div>
      </div>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
        className={form_styles.customFormStyle}
        onSubmit={(e) => {
          e.preventDefault();
          console.log('submit')
          handleConnect();
        }}
      >
        <p style={{fontSize:18,marginBottom:0}}><b>{t.evaluator_info}</b></p>
        <p style={{marginBottom:0}}><b>{t.name_label}</b> {user?.name}</p>
        <p style={{fontSize:18,marginBottom:0}}><b>{t.candidate_info}</b></p>
        <p style={{marginBottom:0}}><b>{t.name_label}</b> {student?.name}</p>
        <p style={{marginBottom:0}}><b>{t.registration_number}</b> {student?.numero_inscricao}</p>
        <p style={{marginBottom:0}}><b>{t.room}:</b> {t.room} {student?.sala?.numero}</p>
        <p style={{marginBottom:0}}><b>{t.status_label}</b> {number_online.includes(student?.id?.toString())?<span style={{color:'green'}}>{t.online}</span>:<span style={{color:'red'}}>{t.offline}</span>}</p>
        


        {isStartMedia==true && <button type="submit"  className="btn btn-info btn-lg btn-outline btn-circle m-r-5" >{t.enter_call} <i
            className="mdi mdi-call-made"
            style={{  color: 'white', fontStyle: 'normal' }}
            >
                </i></button>}

{isStartMedia==false && <Loader compact title={t.loading} description={null} />}

        
      </form>
    </div>
  );
}
